/* LUV Ritual heroes – keyword colourizer
 * Wraps the ritual-specific keyword (Hydration, Barrier, Glow, Clarity,
 * Sensitive) in <span class="luv-accent-word"> in the collection hero
 * title/description and the Go-deeper head title/lede, so the peach accent
 * styled in luv-ritual-heroes.css applies. Pure DOM – no theme edits.
 */
(function () {
  var MAP = {
    "29242014859598": ["Hydration", "Hydrating", "Hydrate"],
    "29242014892366": ["Barrier"],
    "29242014925134": ["Glow", "Glowing", "Radiance", "Radiant"],
    "29242014957902": ["Clarity", "Clear", "Clarifying"],
    "29242014990670": ["Sensitive Reset", "Sensitive", "Calm", "Calming", "Reset"]
  };

  function findActiveKeywords() {
    for (var id in MAP) {
      // any section whose id includes this template id means this page
      if (document.querySelector('[id*="' + id + '"]')) {
        return MAP[id];
      }
    }
    return null;
  }

  function wrapKeywords(el, words) {
    if (!el || el.dataset.luvAccented === "1") return;
    var html = el.innerHTML;
    // already wrapped? skip
    if (/luv-accent-word/.test(html)) { el.dataset.luvAccented = "1"; return; }

    // Sort words by length descending so "Sensitive Reset" matches before "Sensitive"
    var sorted = words.slice().sort(function (a, b) { return b.length - a.length; });
    var changed = false;
    sorted.forEach(function (w) {
      // word-boundary, case-insensitive, avoid double-wrapping by checking we're not inside a tag
      var re = new RegExp("(^|[\\s>(,.])(" + w.replace(/[-/\\^$*+?.()|[\\]{}]/g, "\\$&") + ")(?![^<]*</span>)", "gi");
      var next = html.replace(re, function (m, pre, hit) {
        changed = true;
        return pre + '<span class="luv-accent-word">' + hit + "</span>";
      });
      html = next;
    });
    if (changed) {
      el.innerHTML = html;
      el.dataset.luvAccented = "1";
    }
  }

  function run() {
    var words = findActiveKeywords();
    if (!words) return;
    var targets = [
      ".collection-hero__title",
      ".collection-hero__description",
      ".collection-hero__description p",
      ".luv-deepbox__title",
      ".luv-deepbox__lede"
    ];
    targets.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { wrapKeywords(el, words); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  // also retry after a tick in case theme JS rewrites inner HTML
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();
